import { render, staticRenderFns } from "./ActionItemList.vue?vue&type=template&id=59c9deee&scoped=true&"
import script from "./ActionItemList.vue?vue&type=script&lang=js&"
export * from "./ActionItemList.vue?vue&type=script&lang=js&"
import style0 from "./ActionItemList.vue?vue&type=style&index=0&id=59c9deee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c9deee",
  null
  
)

export default component.exports